import React from 'react';
import { Progress } from 'seduo-ui';
import classNames from 'classnames';
const StepsProgress = ({ step, maxStep, className, small }) => {
    return (<div className="progress-steps-overlay">
            <div className="progress-steps-layer">
                {[...Array(maxStep)].map((x, i) => (<span className="progress-steps-layer-step" key={i} style={{
                width: `${100 / maxStep}%`,
                left: `${(100 / maxStep) * i}%`,
            }}/>))}
            </div>
            <Progress value={(100 / maxStep) * step} className={classNames({
            'progress--small': small === true,
            className,
        })}/>
        </div>);
};
StepsProgress.defaultProps = {
    small: false,
};
export default StepsProgress;
